/**
 * @description 导出企业聊天相关的getters
 */
export default {
  onGetContactUserList(state) {
    return state.userListStu.contactUserList;
  },
  onGetGroupUserList(state) {
    return state.userListStu.groupUserList;
  },
  onGetChatroomUserList(state) {
    return state.userListStu.chatroomUserList;
  },
  onGetCurrentChatObjMsg(state) {
    return state.currentMsgs;
  },
  // 获取单聊中所有的消息
  onAllGetCurrentChatObjMsg(state) {
    return state.msgListStu.contact;
  },
  // 获取群聊中所有的消息
  onAllGetCurrentGroupObjMsg(state) {
    return state.msgListStu.group;
  },
  fetchHistoryMessages(state) {
    return state.currentMsgs;
  },
  onGetCurrentGAllUserStu(state) {
    return state.currentGAllUser
  },
  onGetNoReadNums(state) {
    return state.noReadNums
  },
  singleUnreadInfo(state) {
    return state.singleUnreadInfo
  },
  groupUnreadInfo(state) {
    return state.groupUnreadInfo
  },
  onGetHrInfos(state) {
    return state.hrInfos
  },
  // 获取多端同步1v1通知请求
  onNoticeCallMsg: state => state.noticeCallMsg,
  // 表示计算属性强制更新
  computeForceUpdateNum:state => state.computeForceUpdateNum,
}


// WEBPACK FOOTER //
// ./src/store/stu/getters.js